<template>
<b-col cols="12" sm="6" md="3" class="filter-item">
    <small>
        <b>{{ title }}</b>
        <template v-if="type === 'date-range'">
            <b-link class="float-right" @click="resetDateRange">クリア</b-link>
        </template>
        <hr class="my-1" />

        <template v-if="type === 'date'">
            <b-form-datepicker
                :value="value"
                size="sm"
                class="mb-2"
                placeholder=""
                :start-weekday="1"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'narrow', }"
                @input="$emit('input', $event); $emit('update')"
                close-button
                reset-button
                >
            </b-form-datepicker>
        </template>

        <template v-if="type === 'date-range'">
            <small>開始</small>
            <b-form-datepicker
                v-model="date1"
                size="sm"
                placeholder=""
                :start-weekday="1"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'narrow', }"
                @input="inputDateRange($event, 'date1')"
                close-button
                reset-button
                >
            </b-form-datepicker>

            <small>終了</small>
            <b-form-datepicker
                v-model="date2"
                size="sm"
                class="mb-3"
                placeholder=""
                :start-weekday="1"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'narrow', }"
                @input="inputDateRange($event, 'date2')"
                close-button
                reset-button
                >
            </b-form-datepicker>

            <small>年月を選択</small>
            <div class="mb-3">
                <month-picker
                    v-model="date_month"
                    class="w-100"
                    :no-default="true"
                    :clearable="true"
                    lang="ja"
                    @input="inputMonthPicker"
                    ref="date_month"
                    />
            </div>
        </template>

        <template v-if="!type || type === 'text'">
        <b-form-group label="">
            <div
                v-for="option in options"
                :key="option.value"
                >
                <label
                    :active="value === option.value"
                    class="filter-item-option"
                    >
                    <input
                    :checked="value === option.value"
                    :value="option.value"
                    type="radio"
                    @input="$emit('input', option.value); $emit('update')"
                    />
                    <span class="filter-item-option-text">{{ option.text }}</span>
                </label>
            </div>
        </b-form-group>
        </template>
    </small>
</b-col>
</template>

<script>

export default {
    components: {
    },
    props: {
        value: {
            type: [ String, Number, ],
            required: true,
            default() {
                return ''
            },
        },
        title: {
            type: String,
            required: true,
            default() {
                return ''
            },
        },
        type: {
            type: String,
            required: false,
        },
        options: {
            type: [ Array, Object, ],
            required: true,
            default() {
                return []
            },
        },
    },
    data() {
        return {
            date1: null,
            date2: null,
            date_month: {
                from: null,
                to: null,
                month: null,
                year: null
            },
            store_id: null,
            section_id: null,
        }
    },
    computed: {
        /*
        date1:{
            get() {
                console.log('computed - date1 - get')
                let range = this.parseDateRange(this.value)
                console.log(range.date1)
                return range.date1
            },
            set(newVal) {
                console.log('computed - date2 - set', newVal)
                //                this.$emit("changeMsg", newVal)
                //               console.log(newVal)
            },
        },
        date2:{
            get() {
                console.log('computed - date2 - get')
                let range = this.parseDateRange(this.value)
                console.log(range.date2)
                return range.date2
            },
            set(newVal) {
                console.log('computed - date2 - set', newVal)
                //                this.$emit("changeMsg", newVal)
                //                console.log(newVal)
            },
        },
         */
    },
    watch: {
        value: {
            async handler (newValue, oldValue) {
                if (this.type === 'date-range') {
                    let range = this.parseDateRange(newValue)
                    this.date1 = range.date1
                    this.date2 = range.date2
                }
            },
            immediate: true
        }
    },
    async mounted() {},
    methods: {
        inputDateRange(date, field) {
            let date1 = this.date1
            let date2 = this.date2
            switch (field) {
                case 'date1':
                date1 = date
                break;
                case 'date2':
                date2 = date
                break;
            }
            let range = this.parseDateRange([ date1, date2, ].join(','))
            this.$nextTick(() => {
                this.date1 = range.date1
                this.date2 = range.date2

                this.$emit('input', [ range.date1, range.date2, ].join(','))
                this.$emit('update')
            })
        },
        parseDateRange(date) {
            let dates = date.split(',')
            let date1 = (dates.length >= 1) ? dates[0] : null
            let date2 = (dates.length >= 2) ? dates[1] : null

            date1 = this.$moment(date1) || null
            if (date1 && date1.isValid()) {
                date1 = date1.format('YYYY-MM-DD')
            } else {
                date1 = null
            }

            date2 = this.$moment(date2) || null
            if (date2 && date2.isValid()) {
                date2 = date2.format('YYYY-MM-DD')
            } else {
                date2 = null
            }

            if (date1 && date2) {
                if (date1 > date2) {
                    let work = date1
                    date1 = date2
                    date2 = work
                }
            } else if (this.options.force_range !== false) {
                if (date1) {
                    date2 = date1
                } else if (date2) {
                    date1 = date2
                }
            }

            return {
                date1: date1,
                date2: date2,
            }
            //            this.date1 = date1
            //            this.date2 = date2
        },
        resetDateRange() {
            this.date1 = null
            this.date2 = null
            this.inputDateRange()
        },
        inputMonthPicker(value) {
            let date1 = this.$moment(value.from).format('YYYY-MM-DD')
            let date2 = this.$moment(value.to).subtract(1, 'days').format('YYYY-MM-DD')

            this.$nextTick(() => {
                this.date1 = date1
                this.date2 = date2

                this.$emit('input', [ date1, date2, ].join(','))
                this.$emit('update')
            })
        },
        inputSection (value) {
            this.$emit('input', value)
            this.$emit('update')
        },
        reduceStore (e) {
            return e.id + '-'
        },
        reduceSection (e) {
            return e.store_id + '-' + e.id
        },
        reduceStoreSection (selectedStore, selectedSection) {
            let store_id = null
            let section_id = null
            if (selectedStore) {
                store_id = selectedStore.id
            }
            if (selectedSection) {
                section_id = selectedSection.id
            }
            return [ store_id, section_id, ].join('-')
        },
        parseStoreSection (value) {
            return {
                store_id: null,
                section_id: null,
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.filter-item {
    .filter-item-option {
        display: block;

        &[active] {
        }

        &:not([active]) {
            opacity: 0.3;
        }

        [type='radio'] {
            display: none;
        }

        .filter-item-option-text {
            cursor: pointer;
        }
    }
}
</style>

<style lang="scss">
.filter-item {
    .b-form-datepicker {
        [aria-haspopup="dialog"] {
            width: 0px;
            padding: 0;
            overflow: hidden;
        }
    }
    .month-picker__container {
        .month-picker__year {
            button {
                width: 1.5em;
                line-height: 1em;
            }
            p {
                font-size: 1.2em;

                &::after {
                    content: '年';
                }
            }
        }
    }
}
</style>


